import { Inbox } from "@assets";

export const NoCompletedAssessments = (): JSX.Element => {
    return (
        <div className="w-80">
            <div className="box my-6">
                <div className="is-flex is-flex-direction-column is-justify-content-center is-align-items-center has-text-center">
                    <div className="title my-5">There are no completed assessments yet</div>
                    <Inbox />
                </div>
            </div>
        </div>
    );
};
